import * as TypeGraphQL from "type-graphql";
export var ConflictEventScalarFieldEnum;
(function (ConflictEventScalarFieldEnum) {
    ConflictEventScalarFieldEnum["id"] = "id";
    ConflictEventScalarFieldEnum["timestamp"] = "timestamp";
    ConflictEventScalarFieldEnum["entityType"] = "entityType";
    ConflictEventScalarFieldEnum["entityId"] = "entityId";
    ConflictEventScalarFieldEnum["serverVersion"] = "serverVersion";
    ConflictEventScalarFieldEnum["clientVersion"] = "clientVersion";
    ConflictEventScalarFieldEnum["strategy"] = "strategy";
    ConflictEventScalarFieldEnum["resolved"] = "resolved";
    ConflictEventScalarFieldEnum["resolution"] = "resolution";
    ConflictEventScalarFieldEnum["resolutionTime"] = "resolutionTime";
})(ConflictEventScalarFieldEnum || (ConflictEventScalarFieldEnum = {}));
TypeGraphQL.registerEnumType(ConflictEventScalarFieldEnum, {
    name: "ConflictEventScalarFieldEnum",
    description: undefined,
});
//# sourceMappingURL=ConflictEventScalarFieldEnum.js.map